export function Badge({ children, color = '#3b82f6' }) {
  return (
    <span
      style={{
        backgroundColor: color,
        color: '#fff',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        fontSize: '0.8rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
      }}
    >
      {children}
    </span>
  );
}
